import React from 'react';

import { StyleSheet } from 'react-native';

import SodiumFlag from 'components/product-detail-v2/nutrition-information/sodium-flag';
import { Typography } from 'components/ui';
import { useLocale } from 'state/intl';
import { Region } from 'utils/environment/types';

export const SodiumDisclaimerUS = () => {
  const { region } = useLocale();
  if (region === Region.US) {
    return (
      <Typography variant="copyTwo">
        Warning: <SodiumFlag size="22px" style={styles.icon} /> indicates that sodium (salt) content
        of this item is higher than the total daily recommended limit (2,300mg). High Sodium intake
        can increase blood pressure and risk of heart disease and stroke.
      </Typography>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  icon: {
    transform: [{ translateY: 3 }],
  },
});
